import { useState, useEffect } from 'react';
import SkuService from './SkuService';

const useManageSku = () => {
  const [skus, setSku] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const getSkus = async () => {
    setIsLoading(true);
    try {
      const response = await SkuService.getSkus();
      console.log(response.data)
      setError(null);
      setSku(response.data)
      return response.data
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const addSku = async (formData) => {
    console.log(formData)
    let result = true
    setIsLoading(true);
    try {
        await SkuService.addSku(formData);
        await getSkus()
        result = true
    } catch (err) {
        console.log(err.response.data.message || 'An error occurred.');
        result = err.response.data.message
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const editSku = async (id, formData) => {
    let result = true
    setIsLoading(true);
    try {
      const response = await SkuService.editSku(id, formData);
      await getSkus()
      setError(null);
    } catch (err) {
        setError(err);
        result = err.response.data.message
    } finally {
        setIsLoading(false);
        return result
    }
  };

  const deleteSku = async (categoryId) => {
    setIsLoading(true);
    let result = true
    try {
        await SkuService.deleteSku(categoryId);
        await getSkus()
    } catch (err) {
      result = false
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
        return result
    }
  };


  return { 
    skus,
    getSkus,
    addSku,
    editSku,
    deleteSku,
  };
}

export default useManageSku;
